import { render, staticRenderFns } from "./AtualizacaoDadosSegurado.vue?vue&type=template&id=62da5b50"
import script from "./AtualizacaoDadosSegurado.vue?vue&type=script&lang=js"
export * from "./AtualizacaoDadosSegurado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports